import Swal from "sweetalert2";
import "../pages/game/gameStagePopup.css";

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** National Heist CTA gradient stops (theme button_color / begin_button_color). */
const HEIST_BTN_START = "#e25569";
const HEIST_BTN_END = "#fb9946";
const HEIST_BTN_FALLBACK = "#e9695e";

function resolveThemeButtonColor(themeData) {
  const raw =
    themeData?.begin_button_color ||
    themeData?.button_color ||
    themeData?.colors?.ui_color_2 ||
    themeData?.colors?.ui_color_1;
  if (raw == null || String(raw).trim() === "") return HEIST_BTN_FALLBACK;
  return String(raw).trim();
}

function lightenHex(hex, amount = 0.22) {
  const h = String(hex || "").replace("#", "").trim();
  if (!/^[0-9a-fA-F]{6}$/.test(h) && !/^[0-9a-fA-F]{8}$/.test(h)) {
    return HEIST_BTN_END;
  }
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const mix = (c) => Math.min(255, Math.round(c + (255 - c) * amount));
  return `#${[mix(r), mix(g), mix(b)]
    .map((n) => n.toString(16).padStart(2, "0"))
    .join("")}`;
}

function resolveIconMarkup(icon) {
  if (icon === "success") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--success" aria-hidden="true">✓</div>`;
  }
  if (icon === "info") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--info" aria-hidden="true">i</div>`;
  }
  if (icon === "error") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--error" aria-hidden="true">✕</div>`;
  }
  if (icon) {
    return `<div class="game-stage-popup__icon" aria-hidden="true">${escapeHtml(icon)}</div>`;
  }
  return "";
}

/**
 * Themed in-game alert using National Heist colors (brown parchment shell + coral CTA).
 */
export function fireGameStagePopup({
  title,
  html = "",
  icon = "success",
  variant,
  confirmButtonText = "OK",
  confirmButtonColor,
  themeData,
} = {}) {
  const popupVariant =
    variant ||
    (icon === "error" ? "error" : icon === "info" ? "info" : "success");

  const themeBtn = resolveThemeButtonColor(themeData);
  const start = confirmButtonColor || themeBtn || HEIST_BTN_START;
  const end =
    confirmButtonColor || lightenHex(themeBtn, 0.28) || HEIST_BTN_END;

  return Swal.fire({
    html: `<div class="game-stage-popup">
      ${resolveIconMarkup(icon)}
      <h2 class="game-stage-popup__title">${escapeHtml(title)}</h2>
      <div class="game-stage-popup__body">${html}</div>
      <button type="button" class="game-stage-popup__btn" data-game-stage-popup-close>${escapeHtml(confirmButtonText)}</button>
    </div>`,
    showConfirmButton: false,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: true,
    width: "min(92vw, 26em)",
    heightAuto: true,
    scrollbarPadding: false,
    returnFocus: false,
    customClass: {
      popup: `game-stage-popup-shell game-stage-popup-shell--${popupVariant}`,
      htmlContainer: "game-stage-popup-shell__html",
    },
    showClass: { popup: "game-stage-popup-shell--in" },
    didOpen: () => {
      const btn = Swal.getPopup()?.querySelector("[data-game-stage-popup-close]");
      if (btn) {
        btn.style.background = `linear-gradient(to right, ${start}, ${end})`;
        btn.style.boxShadow = `0 4px 16px ${start}66`;
        btn.addEventListener("click", () => Swal.close(), { once: true });
      }
    },
  });
}
